import styled from 'styled-components';

export const Navigation = styled.nav`
    width: auto;
    padding: 8px;
    background-color: #81D4FA;
`;

export const NavigationList = styled.ul`
    margin: 0;
    padding: 8px;
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    list-style: none;
`

export const NavigationListItem = styled.li`
    a { 
        color: #212121;
        text-decoration: none;
    };
`

export const NavigationListItemRight = styled(NavigationListItem)`
    margin-left: auto;
`